import { Card, DatePicker, Input } from "antd";
import Dropdown from "../common/dropdown";
import { useEffect, useState } from "react";
import moment from "moment";
import { adsTypes, offerTypes } from "../../api/ads";
import { UsaStates } from "usa-states";

const AdsNewService = ({ dropData, value }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [offers, setOffers] = useState();
  const [types, setTypes] = useState();
  const handleDateChange = (date) => {
    setSelectedDate(date);
    dropData({
      ...value,
      date: moment(selectedDate?.$d).format("YYYY-MM-DDTHH:mm:ss.SSZ"),
    });
  };
  const disabledDate = (current) => {
    return current && current < moment().startOf("day");
  };
  const usStates = new UsaStates();
  const days = [
    {
      name: "1 Day",
      _id: "1",
    },
    {
      name: "2 Days",
      _id: "2",
    },
    {
      name: "3 Days",
      _id: "3",
    },
    {
      name: "4 Days",
      _id: "4",
    },
    {
      name: "5 Days",
      _id: "5",
    },
    {
      name: "6 Days",
      _id: "6",
    },
    {
      name: "7 Days",
      _id: "7",
    },
    {
      name: "8 Days",
      _id: "8",
    },
    {
      name: "9 Days",
      _id: "9",
    },
    {
      name: "10 Days",
      _id: "10",
    },
    {
      name: "11 Days",
      _id: "11",
    },
    {
      name: "12 Days",
      _id: "12",
    },
    {
      name: "13 Days",
      _id: "13",
    },
    {
      name: "14 Days",
      _id: "14",
    },
    {
      name: "15 Days",
      _id: "15",
    },
    {
      name: "16 Days",
      _id: "16",
    },
    {
      name: "17 Days",
      _id: "17",
    },
    {
      name: "18 Days",
      _id: "18",
    },
    {
      name: "19 Days",
      _id: "19",
    },
    {
      name: "20 Days",
      _id: "20",
    },
    {
      name: "21 Days",
      _id: "21",
    },
    {
      name: "22 Days",
      _id: "22",
    },
    {
      name: "23 Days",
      _id: "23",
    },
    {
      name: "24 Days",
      _id: "24",
    },
    {
      name: "25 Days",
      _id: "25",
    },
    {
      name: "26 Days",
      _id: "26",
    },
    {
      name: "27 Days",
      _id: "27",
    },
    {
      name: "28 Days",
      _id: "28",
    },
    {
      name: "29 Days",
      _id: "29",
    },
    {
      name: "30 Days",
      _id: "30",
    },
  ];

  const fetchData = async () => {
    const res = await adsTypes();
    setTypes(res);
    const offertype = await offerTypes();
    setOffers(offertype);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Card className="shadow-md">
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-3 mx-3 mb-2">
        <div>
          <p className="text-lg font-bold text-primaryPurple sm:line-clamp-1">
            Number Of Days
          </p>
          <Dropdown
            className="w-full rounded-md"
            data={days}
            placeholder={"Select Days"}
            onChange={(e) => {
              dropData({ ...value, days: e });
            }}
          />
        </div>
        <div>
          <p className="text-lg font-bold text-primaryPurple sm:line-clamp-1">
            Advertisement Type
          </p>
          <Dropdown
            className="w-full rounded-md"
            data={types}
            placeholder={"Promoted Post"}
            onChange={(e) => {
              dropData({ ...value, type: e });
            }}
          />
        </div>
        <div>
          <p className="text-lg font-bold text-primaryPurple">Start Date</p>
          <DatePicker
            value={selectedDate}
            placeholder="Select Date"
            onChange={handleDateChange}
            format="YYYY-MM-DD"
            disabledDate={disabledDate}
            className="border h-5.4 w-full rounded-xl text-lg pl-2 flex justify-between text-grey text-sm"
          />
        </div>
        <div>
          <p className="text-lg font-bold text-primaryPurple">City</p>
          <Input
            className="w-full rounded-lg h-5.4"
            placeholder={"City"}
            onChange={(e) => {
              dropData({ ...value, city: e.target.value });
            }}
          />
        </div>
        <div className="mb-3">
          <p className="text-lg font-bold text-primaryPurple">State</p>
          <Dropdown
            className="w-full"
            data={usStates?.states}
            placeholder={"States"}
            onChange={(e) => {
              dropData({ ...value, state: e });
            }}
          />
        </div>
        <div className="mb-3">
          <p className="text-lg font-bold text-primaryPurple">Offer Type</p>
          <Dropdown
            className="w-full"
            data={offers}
            placeholder={"Offer type"}
            onChange={(e) => {
              dropData({ ...value, offer: e });
            }}
          />
        </div>
      </div>
    </Card>
  );
};
export default AdsNewService;
